import { type JanusCtx, type Row, ecLean, itemField } from './context.js';
import { phpJsonInt } from '../compile/php-json-values.js';

/** ft_effective_ability_dc: a nonblank lair override wins; NULL/blank uses the authored DC.
 * The legacy contest branches require ability_dc before consulting the override, so a skill
 * contest remains a skill contest even when its caster is a lair. */
export function effectiveAbilityDc(ctx: JanusCtx, caster: Row, ability: Row): number | null {
  if (!ctx.read.has(ability, 'ability_dc')) return null;
  if (String(itemField(caster, 'item_type') ?? ecLean(caster, 'item_type') ?? '') === 'lair') {
    const dc = ecLean(caster, 'lair_dc');
    if (dc !== null && dc !== undefined && dc !== '') return phpJsonInt(dc);
  }
  const authored = ctx.read.value(ability, 'ability_dc');
  return authored === null || authored === undefined || authored === '' ? null : phpJsonInt(authored);
}
